module.exports = __webpack_public_path__ + "img/timeline-05.d3928a1d.jpg";